import { useContext } from "react";
import { ProjectsManagerContext } from "../context/ProjectsManagerContext";

export const useProjectsManager = () => {
  const projectsManager = useContext(ProjectsManagerContext);
  if (!projectsManager)
    throw new Error(
      "useProjectsManager must be used within a ProjectsManagerProvider"
    );
  return projectsManager;
};
